import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment-timezone';
import Icon from '../../common/icons/Icon';

class HistoryModal extends Component {
  static propTypes = {
    sessions: PropTypes.array.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  getSessionIcon = sessionType => {
    let sessionIcon = '';

    switch (sessionType) {
      case 'online':
        sessionIcon = 'Computer';
        break;
      case 'in-person':
        sessionIcon = 'People';
        break;
      case 'movement-specialist':
        sessionIcon = 'Golf';
        break;
      default:
        sessionIcon = 'Tathata-Logo';
    }

    return sessionIcon;
  };

  render() {
    const { sessions, toggleModal } = this.props;

    return (
      <div className="booking-modal session-history__modal">
        <button className="close-button" onClick={toggleModal}>
          <Icon icon="Close" />
        </button>
        <div className="booking-modal--header">
          <Icon icon="Tathata-Logo" />
          <h3>Follow-Up History</h3>
        </div>
        <ul className="session-history__list">
          {sessions.map((session, index) => {
            const date = moment(session.accepted_session_date).tz(session.time_zone_id);

            return (
              <li key={`date-${index}`} className="session-list__item">
                <div className="session-history__ms">
                  {!session.movementSpecialist
                    ? (
                      <div className="ms__request-hist-icon">
                        <Icon icon={this.getSessionIcon(session.type)} />
                      </div>
                    )
                    : (
                      <div
                        style={{
                          backgroundImage: `url(${get(
                            session,
                            'movementSpecialist.movementSpecialistProfile.profileImage.location'
                          )})`,
                        }}
                        className="ms__request-img"
                      />
                    )
                  }
                  {
                    <span className="sess-type">
                      {get(session, 'movementSpecialist.movementSpecialistProfile.name') || session.type}
                    </span>
                  }
                </div>
                <div>
                  {date.format('L')} @ {date.format('h:mmA')}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default HistoryModal;



// WEBPACK FOOTER //
// ./src/subscription/sessions/HistoryModal.js